import { enqueueSnackbar } from "notistack";

const handleError = (
  translation: string,
  message: string,
  errorAction?: () => void,
) => {
  errorAction && errorAction();
  enqueueSnackbar(`${translation} - ${message}`, {
    variant: "error",
  });
};

// TODO: Uncomment once authentication has been implemented
const authorizationHeaders = (token: string | null) => {
  return {
    Authorization: token ? `Bearer ${token}` : "",
    //"Ocp-Apim-Subscription-Key": apiKey,
  };
};

//the following arguments specify query parameters whose results should be treated as two different entries in cache instead of overwriting each other.
//ex.: a query with parameters {where: {id: 1}} and {where: {id: 2}}
//ex.: a query with parameters {order: {date: ASC}} and {order: {priority: ASC}}
const offsetPaginationQueryParameters = ["where", "order"];

//declare your Union Types here in order for ApolloClient to know how to handle them
const graphqlUnionTypes = {
  InboundDeliveryDetailItem: ["HandlingUnitItem", "MaterialItem"],
};

export {
  authorizationHeaders,
  graphqlUnionTypes,
  handleError,
  offsetPaginationQueryParameters,
};
